import AgeonLogo from './AgeonLogo';

export default function Loader({ message = 'Loading…' }) {
    return (
        <div className="h-screen grid place-items-center bg-ink-50">
            <div className="text-center">
                <AgeonLogo markOnly className="h-12 w-12 mx-auto" />
                <div className="mt-3 font-extrabold tracking-[0.18em] text-brand-teal">AGEON</div>
                <div className="text-xs text-ink-500 mt-1">{message}</div>
            </div>
        </div>
    );
}
